import { FC, DetailedHTMLProps, HTMLAttributes } from "react";
import { startCase } from "lodash";
import { classNames, withRoles } from "utils";
import { UserRole } from "apollo/cache/auth";

const themeMap = {
  primary: "w-full inline-flex justify-center rounded-md border duration-150 border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm",
  neutral: "w-full inline-flex justify-center rounded-md border duration-150 border-gray-300 dark:border-gray-600 shadow-sm px-4 py-2 bg-white dark:bg-gray-900 text-base font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 hover:dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm",
  danger: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
}

interface ButtonProps  extends DetailedHTMLProps<HTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  type?: "submit" | "button" | "reset",
  tooltip?: string;
  disabled?: boolean;
  roles?: UserRole[]
  theme?: keyof typeof themeMap,
}

export const Button: FC<ButtonProps> = ({
  theme = 'primary',
  type = 'button',
  disabled = false,
  tooltip,
  roles,
  className = "",
  ...props
}) => {

  const toolTipProps = tooltip ? {
    "data-tooltip-delay-show": 1000,
    "data-tooltip-id": "global-tooltip",
    "data-tooltip-content": startCase(tooltip)
  } : {}

  const hasPermissions = roles?.length ? withRoles<boolean>(roles)(true, false) : true
  if(!hasPermissions) return <></>


  return (
    <button
      type={type}
      disabled={disabled}
      className={classNames(
        className,
        disabled
          ? "cursor-not-allowed text-gray-500 hover:bg-gray-300"
          : "text-gray-500 hover:bg-gray-300 hover:text-gray-900",
        themeMap[theme],
      )}
      {...toolTipProps}
      {...props}
    >
      {props.children}
    </button>
  );
};